import { render, staticRenderFns } from "./TestimonialListing.vue?vue&type=template&id=a5f9cb00&"
import script from "./TestimonialListing.vue?vue&type=script&lang=js&"
export * from "./TestimonialListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionBaseSection: require('/usr/src/app/components/sections/BaseSection.vue').default})
